export const FETCH_COMPANY = 'app/Dashboard/FETCH_COMPANY';
export const FETCH_COMPANY_SUCCESS = 'app/Dashboard/FETCH_COMPANY_SUCCESS';
export const FETCH_COMPANY_ERROR = 'app/Dashboard/FETCH_COMPANY_ERROR';
